import { createStart, createMiddleware } from "@tanstack/react-start";

/**
 * Project-specific replacement for the generated `attachSupabaseAuth`.
 * Identical behaviour, but the Supabase client is imported lazily so the
 * auth SDK never lands in the initial bundle of public marketing pages.
 */
const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
);

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuthLazy],
}));
